module.exports = __webpack_public_path__ + "img/country.ea4159f8.svg";